module.exports = __webpack_public_path__ + "static/media/check-green.803874b4.svg";